import { observable, action } from 'mobx'
import { getCurrentLanguage } from 'utils/language'
import translate from 'locales'

class LocaleStore {
  @observable locale = 'en'

  @action
  init () {
    this.locale = getCurrentLanguage()
  }

  withNamespace = (namespace) => (key, options) => {
    const t = translate(this.locale)
    return t(`${namespace}.${key}`, options)
  }

  withKey = (key, options) => {
    return translate(this.locale)(key, options)
  }
}

export default LocaleStore
